import { Environment } from "./environment.model";

export const environment: Environment = {
  production: true,
  name: 'dev',
  rh_env: 'staging',
  version: '#APP_VERSION#',
  // Beanstalk. Four pipelines share this `dev` configuration, so cluster-specific
  // hosts belong in environment.k8s.ts.
  API_URL: 'https://hub-cms-api-1-dev.atpco.net',
  FLIGHT_SEARCH_UPA_URL: 'https://hub-cms-api-1-dev.atpco.net/api/upas',
  FLIGHT_SEARCH_CURL_URL: 'https://retailing.apis.atpco.net/routehappy/consolidated',
  msalConfig: { 
    auth: { 
      clientId: '8ceae38c-6dac-4fb6-a39f-9a98c2a36afe',
    }
  },
  apiConfig: {
    scopes: [
      'https://goldlogin.atpco.net/hub-delivery-api/scp.hub-delivery-api',
    ],
    graphScopes: ['user.read'],
    graphUri: 'https://graph.microsoft.com/v1.0/me',
    apiUri: '',
    apiKey: '',
  },
  b2cPolicies: {
    names: { signUpSignIn: 'b2c_1a_oidc_auth_code_flow' },
    authorities: {
      signUpSignIn: {
        authority:
          'https://goldlogin.atpco.net/devatpcob2cgold.onmicrosoft.com/B2C_1A_OIDC_AUTH_CODE_FLOW',
      },
    },
    authorityDomain: 'goldlogin.atpco.net',
    
  },
  redirectUri: 'https://hub-dev.atpco.net',
  postLogoutRedirectUri: 'https://hub-dev.atpco.net',
  silentRedirectUri: 'https://hub-dev.atpco.net/auth-silent.html',
  faroCollectorUrl: 'https://faro-collector-prod-us-east-3.grafana.net/collect/a7bc26e63c304d51f6d8e641468365b2',
  faroAppName: 'Routehappy Hub UI',
  umsInviteDetails: {
    clientId: "c91d7eb1-f458-4ebb-b47a-62d667c963e4",
    redirectUri: "https://hub-dev.atpco.net",
    applicationName: "Routehappy Hub",
    applicationLink: "https://hub-dev.atpco.net",
    templateId: 3
  },
};
